import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { Article } from './Article.entity';
import { Contract } from './Contract.entity';
import { Customer } from './Customer.entity';
import { Project } from './Project.entity';
import { ProjectProcess } from './ProjectProcess.entity';
import { Ticket } from './Ticket.entity';
import { User } from './User.entity';

export class TimeTrackingStopwatch<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: userCode */
  userId?: number;
  /** Alias: startTime */
  startTime?: string;
  /** Alias: stopTime */
  stopTime?: string;
  /** Alias: customerCode */
  customerId?: number;
  /** Alias: projectCode */
  projectId?: number;
  /** Alias: projectStepCode */
  projectProcessId?: number;
  /** Alias: orderConfirmationCode */
  contractId?: number;
  /** Alias: orderConfirmationPositionCode */
  contractPositionId?: number;
  /** Alias: articleWorkItemCode */
  activityArticleId?: number;
  /** Alias: ticketId */
  ticketId?: string;
  /** Alias: note */
  comment?: string;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: project */
  project?: Project<T>;
  /** Alias: projectStep */
  projectProcess?: ProjectProcess<T>;
  /** Alias: user */
  user?: User<T>;
  /** Alias: customer */
  customer?: Customer<T>;
  /** Alias: orderConfirmation */
  contract?: Contract<T>;
  /** Alias: articleWorkItem */
  activityArticle?: Article<T>;
  /** Alias: ticket */
  ticket?: Ticket<T>;

  __typename?: string;
}

const fields: FieldDefinitions<TimeTrackingStopwatch> = {
  id: {
    alias: 'id',
  },
  userId: {
    alias: 'userCode',
  },
  startTime: {
    alias: 'startTime',
  },
  stopTime: {
    alias: 'stopTime',
  },
  customerId: {
    alias: 'customerCode',
  },
  projectId: {
    alias: 'projectCode',
  },
  projectProcessId: {
    alias: 'projectStepCode',
  },
  contractId: {
    alias: 'orderConfirmationCode',
  },
  contractPositionId: {
    alias: 'orderConfirmationPositionCode',
  },
  activityArticleId: {
    alias: 'articleWorkItemCode',
  },
  ticketId: {
    alias: 'ticketId',
  },
  comment: {
    alias: 'note',
  },
  insertTime: {
    alias: 'insertTime',
  },
  updateTime: {
    alias: 'updateTime',
  },
  project: {
    alias: 'project',
    entity: Entities.project,
  },
  projectProcess: {
    alias: 'projectStep',
    entity: Entities.projectProcess,
  },
  user: {
    alias: 'user',
    entity: Entities.user,
  },
  customer: {
    alias: 'customer',
    entity: Entities.customer,
  },
  contract: {
    alias: 'orderConfirmation',
    entity: Entities.contract,
  },
  activityArticle: {
    alias: 'articleWorkItem',
    entity: Entities.article,
  },
  ticket: {
    alias: 'ticket',
    entity: Entities.ticket,
  },
  __typename: {
    alias: '__typename',
  },
};

export const timeTrackingStopwatchEntityDefinition: EntitiyDefinition<TimeTrackingStopwatch> =
  {
    local: {},
    remote: {
      queryName: 'listTimeTrackingStopwatches',
      fragmentName: 'TimeTrackingStopwatch',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'startStoppwatch',
          args: [
            { name: 'projectCode', type: 'Int!' },
            { name: 'startTime', type: 'DateTimeEx!' },
            { name: 'articleWorkItemCode', type: 'Int!' },
            { name: 'customerCode', type: 'Int' },
            { name: 'projectStepCode', type: 'Int' },
            { name: 'orderConfirmationCode', type: 'Int' },
            { name: 'orderConfirmationPositionCode', type: 'Int' },
            { name: 'ticketId', type: 'ID' },
            { name: 'note', type: 'String' },
          ],
        },
      },
    },
    fieldDefinitions: fields,
  };
